@if (show()) {
    <ul class="pagination row pagination-rounded justify-content-between my-2 mt-3">

        <div class="col-12 justify-content-center col-xxl-auto justify-content-xxl-start">
            <ngb-pagination #paginationComponent
                            [collectionSize]="itemsAmount()"
                            (pageChange)="paginate($event)"
                            [page]="currentPage()"
                            [maxSize]="maxSize"
                            [pageSize]="itemsPerPage()">

                <ng-template ngbPaginationPrevious>
                    @if (itemsAmount() > 0) {
                        <i class="ti ti-chevron-left"></i> {{ 'common.pagination.label.previous' | translate }}
                    }
                </ng-template>
                <ng-template ngbPaginationNext>
                    @if (itemsAmount() > 0) {
                        {{ 'common.pagination.label.next' | translate }} <i
                                class="ti ti-chevron-right"></i>
                    }
                </ng-template>
            </ngb-pagination>
        </div>

        <div class="col-12 d-inline-flex align-items-center justify-content-center col-xxl-auto justify-content-xxl-end text-muted">
            <span class="my-1">
                {{
                    'common.pagination.label.info' | translate: {
                        currentPage: paginationComponent.page,
                        pageTotal: (paginationComponent.pageCount | number),
                        itemsTotal: (paginationComponent.collectionSize | number)
                    }
                }}
                </span>
            <select class="form-control form-control-sm form-select-sm m-1" style="width:auto;"
                    [(ngModel)]="itemsPerPage"
                    (ngModelChange)="changeItemsPerPage($event)">
                @for (it of itemsPerPageList; track it) {
                    <option [value]="it">{{ it | number }}</option>
                }
            </select>
            <span class="my-1"> {{ 'common.pagination.label.items_per_page' | translate }}</span>
        </div>
    </ul>
}
